const defendAgainstNaN = (value: number | 'inherit') => {
    if (value === 'inherit') {
        return value;
    }

    return isNaN(value) ? 'inherit' : value;
};

export default defendAgainstNaN;
